module.exports = __webpack_public_path__ + "img/point-pro-2.1f47f07d.png";